import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { TrashIcon, ArrowLeftIcon, ShoppingBagIcon } from 'lucide-react';
export const Cart: React.FC = () => {
  const {
    cartItems,
    removeFromCart,
    updateQuantity,
    cartTotal
  } = useCart();
  if (cartItems.length === 0) {
    return <div className="min-h-[70vh] flex flex-col items-center justify-center px-4 py-16 bg-white dark:bg-gray-900" data-id="element-1130">
        <div className="text-center" data-id="element-1131">
          <div className="inline-flex items-center justify-center w-16 h-16 mb-6 bg-yellow-100 dark:bg-yellow-900/30 rounded-full" data-id="element-1132">
            <ShoppingBagIcon size={32} className="text-yellow-500" data-id="element-1133" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2" data-id="element-1134">
            Your cart is empty
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-6" data-id="element-1135">
            Looks like you haven't added any items to your cart yet.
          </p>
          <Link to="/" className="inline-flex items-center px-5 py-3 bg-yellow-500 hover:bg-yellow-600 text-white rounded-md font-medium transition-all duration-300 transform hover:scale-105" data-id="element-1136">
            <ArrowLeftIcon size={16} className="mr-2" data-id="element-1137" />
            Continue Shopping
          </Link>
        </div>
      </div>;
  }
  return <div className="container mx-auto px-4 py-8 bg-white dark:bg-gray-900 min-h-screen w-full" data-id="element-1138">
      <h1 className="text-3xl font-bold mb-8 text-gray-900 dark:text-white" data-id="element-1139">
        Your Cart
      </h1>
      <div className="flex flex-col lg:flex-row gap-8" data-id="element-1140">
        {/* Cart Items */}
        <div className="lg:w-2/3" data-id="element-1141">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm overflow-hidden" data-id="element-1142">
            <div className="hidden md:grid md:grid-cols-6 bg-gray-50 dark:bg-gray-900 p-4" data-id="element-1143">
              <div className="md:col-span-3" data-id="element-1144">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-1145">
                  Product
                </span>
              </div>
              <div className="text-center" data-id="element-1146">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-1147">
                  Price
                </span>
              </div>
              <div className="text-center" data-id="element-1148">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-1149">
                  Quantity
                </span>
              </div>
              <div className="text-center" data-id="element-1150">
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-1151">
                  Total
                </span>
              </div>
            </div>
            <div className="divide-y divide-gray-200 dark:divide-gray-700" data-id="element-1152">
              {cartItems.map(item => <div key={item.id} className="p-4 md:grid md:grid-cols-6 items-center hover:bg-gray-50 dark:hover:bg-gray-750 transition-colors duration-150" data-id="element-1153">
                  <div className="md:col-span-3 flex items-center" data-id="element-1154">
                    <div className="w-20 h-20 bg-gray-100 dark:bg-gray-800 rounded-md overflow-hidden mr-4" data-id="element-1155">
                      <img src={item.image} alt={item.name} className="w-full h-full object-cover" data-id="element-1156" />
                    </div>
                    <div data-id="element-1157">
                      <Link to={`/product/${item.id}`} className="font-medium text-gray-900 dark:text-white hover:text-yellow-500 transition-colors" data-id="element-1158">
                        {item.name}
                      </Link>
                      <button onClick={() => removeFromCart(item.id)} className="mt-1 flex items-center text-sm text-red-500 hover:text-red-700 transition-colors" data-id="element-1159">
                        <TrashIcon size={14} className="mr-1" data-id="element-1160" />
                        Remove
                      </button>
                    </div>
                  </div>
                  <div className="text-center mt-4 md:mt-0" data-id="element-1161">
                    <span className="text-gray-900 dark:text-white" data-id="element-1162">
                      ${item.price.toLocaleString()}
                    </span>
                  </div>
                  <div className="text-center mt-4 md:mt-0" data-id="element-1163">
                    <div className="inline-flex items-center" data-id="element-1164">
                      <button onClick={() => updateQuantity(item.id, Math.max(1, (item.quantity || 1) - 1))} className="w-8 h-8 flex items-center justify-center bg-gray-100 dark:bg-gray-700 rounded-l-md text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors" data-id="element-1165">
                        -
                      </button>
                      <input type="text" value={item.quantity || 1} readOnly className="w-10 h-8 text-center border-t border-b border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white" data-id="element-1166" />
                      <button onClick={() => updateQuantity(item.id, (item.quantity || 1) + 1)} className="w-8 h-8 flex items-center justify-center bg-gray-100 dark:bg-gray-700 rounded-r-md text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors" data-id="element-1167">
                        +
                      </button>
                    </div>
                  </div>
                  <div className="text-center mt-4 md:mt-0" data-id="element-1168">
                    <span className="font-medium text-gray-900 dark:text-white" data-id="element-1169">
                      ${(item.price * (item.quantity || 1)).toLocaleString()}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
          <div className="flex justify-between mt-6" data-id="element-1170">
            <Link to="/" className="inline-flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:text-yellow-500 transition-colors" data-id="element-1171">
              <ArrowLeftIcon size={16} className="mr-2" data-id="element-1172" />
              Continue Shopping
            </Link>
          </div>
        </div>
        {/* Order Summary */}
        <div className="lg:w-1/3" data-id="element-1173">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6" data-id="element-1174">
            <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-4" data-id="element-1175">
              Order Summary
            </h2>
            <div className="space-y-3 mb-6" data-id="element-1176">
              <div className="flex justify-between text-gray-600 dark:text-gray-400" data-id="element-1177">
                <span data-id="element-1178">Subtotal</span>
                <span className="font-medium text-gray-900 dark:text-white" data-id="element-1179">
                  ${cartTotal.toLocaleString()}
                </span>
              </div>
              <div className="flex justify-between text-gray-600 dark:text-gray-400" data-id="element-1180">
                <span data-id="element-1181">Shipping</span>
                <span className="font-medium text-gray-900 dark:text-white" data-id="element-1182">
                  Calculated at checkout
                </span>
              </div>
              <div className="flex justify-between text-gray-600 dark:text-gray-400" data-id="element-1183">
                <span data-id="element-1184">Tax</span>
                <span className="font-medium text-gray-900 dark:text-white" data-id="element-1185">
                  Calculated at checkout
                </span>
              </div>
              <div className="border-t border-gray-200 dark:border-gray-700 my-4" data-id="element-1186"></div>
              <div className="flex justify-between" data-id="element-1187">
                <span className="font-bold text-gray-900 dark:text-white" data-id="element-1188">
                  Total
                </span>
                <span className="font-bold text-gray-900 dark:text-white" data-id="element-1189">
                  ${cartTotal.toLocaleString()}
                </span>
              </div>
            </div>
            <button className="w-full bg-yellow-500 hover:bg-yellow-600 text-white py-3 px-6 rounded-md font-medium transition-all duration-300 transform hover:scale-105 hover:shadow-lg" data-id="element-1190">
              Proceed to Checkout
            </button>
            <div className="mt-6 text-sm text-gray-600 dark:text-gray-400" data-id="element-1191">
              <p className="mb-2" data-id="element-1192">We accept:</p>
              <div className="flex space-x-2" data-id="element-1193">
                <div className="w-10 h-6 bg-gray-200 dark:bg-gray-700 rounded" data-id="element-1194"></div>
                <div className="w-10 h-6 bg-gray-200 dark:bg-gray-700 rounded" data-id="element-1195"></div>
                <div className="w-10 h-6 bg-gray-200 dark:bg-gray-700 rounded" data-id="element-1196"></div>
                <div className="w-10 h-6 bg-gray-200 dark:bg-gray-700 rounded" data-id="element-1197"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};